import { useLazyQuery } from "@apollo/client";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { loginQuery } from "./queries";
import Button from "../Button/Button";
import InputField from "../InputField/InputField";
import "./LoginForm.scss";
import { getRoutePath } from "routes/route-utils";
import { AdyenRoutesName } from "routes/route-names";
import { AuthPayload, IAuthToken } from "TypesAndInterfaces";
import { displayError } from "utils/displayNotification";
import * as jose from "jose";

const LoginForm = () => {
  //#region hooks
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [loginSuccess, setLoginSuccess] = useState(
    undefined as boolean | undefined
  );
  const [buttonDisabled, setButtonDisabled] = useState(false);
  //#endregion

  const handleSingleUser = (token: string) => {
    const jwt = jose.decodeJwt(token);
    const data = jwt.data as IAuthToken;
    if (data?.marketplaceId) {
      localStorage.setItem("marketplaceId", data.marketplaceId.toString());
      navigate({
        pathname: getRoutePath(AdyenRoutesName.MARKETPLACE_CONTROL),
      });
    }
  };

  //#region API CALLS
  const [login, { loading }] = useLazyQuery<
    { login: AuthPayload },
    { password: string; email: string }
  >(loginQuery, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      if (data) {
        localStorage.setItem("authToken", data.login.authToken);
        localStorage.setItem("user", JSON.stringify(data.login.user));
        setLoginSuccess(true);
        handleSingleUser(data.login.authToken);
        navigate(getRoutePath(AdyenRoutesName.DASHBOARD_MARKETPLACES));
      }
    },
    onError: (e) => {
      setLoginSuccess(false);
      displayError(e.message);
      setTimeout(() => {
        setButtonDisabled(false);
      }, 1500);
    },
  });
  //#endregion

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setButtonDisabled(true);
    login({ variables: { password, email } });
  };

  return (
    <form className="login__form" onSubmit={handleSubmit}>
      <InputField
        label="Email"
        type="text"
        required={true}
        autoFocus={true}
        placeholder="Enter your email"
        icon={""}
        className={loginSuccess! === false ? "invalid-input" : ""}
        onChange={(e: any) => setEmail(e.target.value)}
        value={email}
      />

      <InputField
        label="Password"
        type="password"
        required={true}
        placeholder="Enter your password"
        autoFocus={false}
        icon={""}
        className={loginSuccess! === false ? "invalid-input" : ""}
        onChange={(e: any) => setPassword(e.target.value)}
        value={password}
        showHideButton
      />

      <div className="buttons-container">
        <div className="buttons-container__row">
          <Link to="/login/forgot-password">Forgot Password</Link>
        </div>
        <div className="buttons-container__row">
          {loading ? (
            <Button
              className="button--primary button--grey"
              content="Login in progress..."
              disabled={true}
              key={"btn-disable"}
            ></Button>
          ) : (
            <Button
              type="submit"
              className="button--primary button--block"
              content="Login"
              icon={""}
              disabled={buttonDisabled}
            ></Button>)}
        </div>
      </div>

      <div className="mirakl-button">
        <div className="mirakl-button__row">
          <div>
            <hr className="division-line"></hr> or <hr className="division-line"></hr>
          </div>
        </div>
        <div className="mirakl-button__row">
          <button onClick={() => navigate(getRoutePath(AdyenRoutesName.LOGIN_WITH_MIRAKL))} className="hop-btn_connect">
            <div className="hop-logo_mirakl">
              <img src="/mirakl-logo.svg" alt="Mirakl Logo" />
            </div>
            <span>Sign in with Mirakl</span>
          </button>
        </div>
      </div>
    </form>
  );
};

export default LoginForm;
